export const global_height_breakpoint_lg = {
  "name": "--pf-v5-global--height-breakpoint--lg",
  "value": "48rem",
  "var": "var(--pf-v5-global--height-breakpoint--lg)"
};
export default global_height_breakpoint_lg;